import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import SecretarioLayout, { START_HREF } from '../secretario/layout'
import { ConnectorLogo, StatusBadge } from '../secretario/components'
import { CATEGORIES, PLANNED, connectorsOf } from '../secretario/catalog'
import Icon from '../components/icon'
import { SITE } from '../site'

// Funcionalidades: cada categoría con sus conectores disponibles, sus herramientas y el acceso a su guía.
const Features = () => (
  <SecretarioLayout>
    <Helmet>
      <title>Funcionalidades de Secretario · Correo, calendario, tareas y documentos | Variant</title>
      <meta
        name="description"
        content="Conoce lo que Secretario hace por WhatsApp: correo, calendario, tareas, contactos, documentos y recordatorios, con los conectores disponibles y sus herramientas."
      />
      <link rel="canonical" href={`${SITE.url}/secretario/funcionalidades`} />
      <meta property="og:title" content="Funcionalidades de Secretario" />
      <meta property="og:url" content={`${SITE.url}/secretario/funcionalidades`} />
    </Helmet>

    <section className="sec-page-head">
      <div className="container">
        <span className="sec-eyebrow sec-eyebrow--light">Funcionalidades</span>
        <h1 className="sec-page-head__title">Todo lo que Secretario puede hacer por ti</h1>
        <p className="sec-page-head__lead">
          Organizado por categoría. Cada conector muestra sus herramientas y te lleva a su guía con ejemplos para copiar.
        </p>
        <nav className="sec-jump" aria-label="Categorías">
          {CATEGORIES.filter((c) => connectorsOf(c.id).length).map((c) => (
            <a key={c.id} href={`#${c.id}`}>
              <Icon name={c.icon} size={16} /> {c.name}
            </a>
          ))}
          {PLANNED.length > 0 && <a href="#proximamente">Próximamente</a>}
        </nav>
      </div>
    </section>

    {CATEGORIES.map((cat, i) => {
      const items = connectorsOf(cat.id)
      if (!items.length) return null
      return (
        <section key={cat.id} id={cat.id} className={`sec-section sec-feature${i % 2 ? ' sec-section--tint' : ''}`}>
          <div className="container sec-feature__grid">
            <div className="sec-feature__intro">
              <span className="sec-cat__icon">
                <Icon name={cat.icon} size={22} />
              </span>
              <h2 className="sec-title">{cat.name}</h2>
              <p className="sec-lead">{cat.blurb}</p>
            </div>
            <div className="sec-feature__list">
              {items.map((c) => (
                <article key={c.id} className="sec-connector-card">
                  <header>
                    <ConnectorLogo connector={c} size={44} />
                    <div>
                      <h3>{c.name}</h3>
                      <StatusBadge status={c.status} />
                    </div>
                  </header>
                  <p>{c.summary}</p>
                  <ul className="sec-tool-chips" aria-label={`Herramientas de ${c.name}`}>
                    {c.tools.map((t) => (
                      <li key={t.id}>{t.name}</li>
                    ))}
                  </ul>
                  <Link to={`/secretario/aprende/${c.id}`} className="sec-link">
                    Ver guía y ejemplos <Icon name="arrow" size={16} />
                  </Link>
                </article>
              ))}
            </div>
          </div>
        </section>
      )
    })}

    {PLANNED.length > 0 && (
      <section className="sec-section sec-section--tint" id="proximamente">
        <div className="container">
          <div className="sec-head">
            <span className="sec-eyebrow">Próximamente</span>
            <h2 className="sec-title">En nuestra hoja de ruta</h2>
            <p className="sec-lead">
              Integraciones que estamos evaluando. Todavía no están disponibles y no tienen fecha confirmada.
            </p>
          </div>
          <div className="sec-planned">
            {PLANNED.map((c) => (
              <article key={c.id} className="sec-planned__item">
                <ConnectorLogo connector={c} size={40} />
                <div>
                  <h3>{c.name}</h3>
                  <p>{c.summary}</p>
                </div>
                <StatusBadge status={c.status} />
              </article>
            ))}
          </div>
        </div>
      </section>
    )}

    <section className="sec-section">
      <div className="container">
        <div className="sec-band">
          <h2>¿Listo para delegar lo repetitivo?</h2>
          <p>Solicita acceso anticipado y conecta tus herramientas en minutos.</p>
          <div className="btn-row">
            <Link to={START_HREF} className="sec-btn sec-btn--accent">
              Comenzar ahora <Icon name="arrow" size={18} />
            </Link>
            <Link to="/secretario/aprende" className="sec-btn sec-btn--glass">
              Aprende a usar Secretario
            </Link>
          </div>
        </div>
      </div>
    </section>
  </SecretarioLayout>
)

export default Features
